import { render } from "./ProductDetailsPage.vue?vue&type=template&id=294f085e&ts=true"
import script from "./ProductDetailsPage.vue?vue&type=script&lang=ts"
export * from "./ProductDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__